<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="closeDialog()">
        <template v-slot:activator="{ on }">
          <span v-on="on" v-html="getReport()"></span>
        </template>
        <v-card>
          <v-toolbar dark class="black--text" :color="$store.getters.stdColorLight">
            <v-btn icon dark @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ this.$store.getters.report.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-show="this.$store.getters.report.reportData.inputType=='LIST'" :color="$store.getters.stdColorDark" text @click="getReportData('XLSX')">{{ $t("message.downloadExcel") }}</v-btn>
            <v-btn :color="$store.getters.stdColorDark" text @click="getReportData('PDF')">{{ $t("message.downloadPdf") }}</v-btn>
          </v-toolbar>
          <v-card-text>
            <p><span v-html="reportContent"></span></p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";

export default {
  name: "optima-report",

  data: () => ({
    webService: null,

    dialog: true,
    reportContent: "",
    reports: [],
    onlyOnce: false
  }),

  created() {
    this.webService=new WebService(this);

    /* this.$store.watch(
      function(state) {
        return state.report.showReport;
      },
      () => {
        this.getReport();
      },
      {
        deep: true //add this if u need to watch object properties change etc.
      }
    ); */
  },

  methods: {
    closeDialog()
    {
      this.$store.dispatch("setReport", { showReport: false, name: "", title: "",
        reportData: {
          name: "",
          outputType: "HTML",
          inputType: "LIST",
          parameters: [],
          dataSets: []
        }
      });
      this.reportContent="";
      this.reports=[];
      this.onlyOnce=false;
      this.dialog=false;
    },
    
    getReport() {
      if (this.$store.getters.showReport)
      {
        if (this.onlyOnce==false)
        {
          this.onlyOnce=true;

          this.reports = []
          if (this.$store.getters.report.reportData.inputType=='LIST')
          {
            this.getSingleReport(this.$store.getters.report.reportData, 1);
          }
          else
          {
            // FORM
            this.getSingleReport(this.$store.getters.report.reportData, 1);
            
            /* var localReportData;
            var nrOfReports = this.$store.getters.report.reportData.dataSets[0].selections[0].values.length;
            for (var i = 0; i < nrOfReports; i++)
            {
              localReportData = JSON.parse(JSON.stringify(this.$store.getters.report.reportData));
              localReportData.dataSets[0].selections[0].values = [this.$store.getters.report.reportData.dataSets[0].selections[0].values[i]]
              this.getSingleReport(localReportData, nrOfReports);
            } */
          }
        }
      }
    },

    getReportData(reportType) {
      if (reportType=="PDF" && this.$store.getters.report.reportData.inputType=="FORM")
      {
        if (this.$store.getters.report.reportData.dataSets[0].selections[0].field=="re_nr" && this.$store.getters.report.reportData.dataSets[0].selections[0].table=="faktura")
        {
          var fakturaTyp=this.getFakturaTyp().toString()
          this.webService.setPrintStatus(this.$store.getters.setPrintStatus, this.$store.getters.report.reportData)
            .then(response => {
              if (response.request.status==200)
              {
                if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
                {
                  //re-read faktura data
                  this.webService.getItems(this.$store.getters.fakturaEntities+"/"+fakturaTyp)
                    .then(response => {
                      this.$store.dispatch("setFakturaList", response.data);

                      this.webService.getReportAsBlob(this.$store.getters.getReport,this.$store.getters.report.reportData,reportType)
                        .then(blob => {
                          if (blob.data.size > 0) {
                            const url = URL.createObjectURL(blob.data);
                            window.open(url);
                          }
                        })
                        // eslint-disable-next-line
                        .catch(err => {
                          console.log(err)
                        });
                    })
                    .catch(err => { console.log(err) });
                }
                else
                {
                  this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
                }
              }
            })
            .catch(err => { console.log(err) });
        }
      }
      else
      {
        this.webService.getReportAsBlob(this.$store.getters.getReport,this.$store.getters.report.reportData,reportType)
          .then(blob => {
            if (blob.data.size > 0) {
              const url = URL.createObjectURL(blob.data);
              window.open(url);
            }
          })
          // eslint-disable-next-line
          .catch(err => {
            console.log(err)
          });
      }
    },

    getSingleReport(localReportData,nrOfreports) {
      this.webService.getReport(this.$store.getters.getReport,localReportData)
        .then(response => {
          this.reports.push(response.data)
          if (this.reports.length==nrOfreports)
          {
            for (var i = 0; i < this.reports.length; i++)
            {
              this.reportContent=this.reportContent+this.reports[i];
            }            
          }
        })
        // eslint-disable-next-line
        .catch(err => {
          console.log(err)
        });
    },

    getFakturaTyp()
    {
      if (this.$store.getters.report.reportData.name=="optimaw_invoice" || this.$store.getters.report.reportData.name=="optimaw_invoice_l")
        return this.$store.getters.FAKTURA_FAKTURA
      if (this.$store.getters.report.reportData.name=="optimaw_rapport" || this.$store.getters.report.reportData.name=="optimaw_rapport_l")
        return this.$store.getters.FAKTURA_RAPPORT
      if (this.$store.getters.report.reportData.name=="optimaw_offerte" || this.$store.getters.report.reportData.name=="optimaw_offerte_l")
        return this.$store.getters.FAKTURA_OFFERTE
      if (this.$store.getters.report.reportData.name=="optimaw_auftrag" || this.$store.getters.report.reportData.name=="optimaw_auftrag_l")
        return this.$store.getters.FAKTURA_AUFTRAG
      if (this.$store.getters.report.reportData.name=="optimaw_quittung" || this.$store.getters.report.reportData.name=="optimaw_quittung_l")
        return this.$store.getters.FAKTURA_VERBUCHT
    }

  }

};
</script>

<style scoped>
</style>
